import { render, staticRenderFns } from "./ScaDetail_tab.vue?vue&type=template&id=b6933c84&scoped=true&"
import script from "./ScaDetail_tab.vue?vue&type=script&lang=ts&"
export * from "./ScaDetail_tab.vue?vue&type=script&lang=ts&"
import style0 from "./ScaDetail_tab.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ScaDetail_tab.vue?vue&type=style&index=1&id=b6933c84&scoped=true&lang=scss&"
import style2 from "./ScaDetail_tab.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6933c84",
  null
  
)

export default component.exports